const SERVICE_ID="service_hvtipdw"
const TEMPLATE_ID="template_x7m5tjn" 
const USER_ID="user_vponeLZVFWtRm67TYoxyx"

export {SERVICE_ID,TEMPLATE_ID,USER_ID}